(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["basic-service"] = factory();
	else
		root["basic-service"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/caching/Cache.ts":
/*!******************************!*\
  !*** ./src/caching/Cache.ts ***!
  \******************************/
/*! exports provided: Cache */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cache", function() { return Cache; });
/* harmony import */ var _CacheItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CacheItem */ "./src/caching/CacheItem.ts");

var Cache = /** @class */function () {
    function Cache() {
        this.items = [];
    }
    Cache.prototype.add = function (id, params, promise, expiry) {
        if (expiry === void 0) {
            expiry = null;
        }
        var item = new _CacheItem__WEBPACK_IMPORTED_MODULE_0__["CacheItem"](id, JSON.stringify(params, Object.keys(params).sort()), promise, new Date(), expiry ? expiry : new Date(8640000000000000));
        this.items.push(item);
        return item;
    };
    Cache.prototype.get = function (id, params) {
        return this.items.find(function (item) {
            return item.id == id && item.params == JSON.stringify(params, Object.keys(params).sort());
        });
    };
    Cache.prototype.remove = function (id, params) {
        var idx = this.items.findIndex(function (item) {
            return item.id == id && item.params == JSON.stringify(params, Object.keys(params).sort());
        });
        if (idx > -1) {
            this.items.splice(idx, 1);
        }
    };
    return Cache;
}();


/***/ }),

/***/ "./src/caching/CacheItem.ts":
/*!**********************************!*\
  !*** ./src/caching/CacheItem.ts ***!
  \**********************************/
/*! exports provided: CacheItem */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CacheItem", function() { return CacheItem; });
var CacheItem = /** @class */function () {
    function CacheItem(id, params, promise, created, expires) {
        this.id = id;
        this.params = params;
        this.promise = promise;
        this.created = created;
        this.expires = expires;
    }
    return CacheItem;
}();


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! exports provided: Cache, CacheItem, Service */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _caching_Cache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./caching/Cache */ "./src/caching/Cache.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Cache", function() { return _caching_Cache__WEBPACK_IMPORTED_MODULE_0__["Cache"]; });

/* harmony import */ var _caching_CacheItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./caching/CacheItem */ "./src/caching/CacheItem.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CacheItem", function() { return _caching_CacheItem__WEBPACK_IMPORTED_MODULE_1__["CacheItem"]; });

/* harmony import */ var _services_Service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./services/Service */ "./src/services/Service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Service", function() { return _services_Service__WEBPACK_IMPORTED_MODULE_2__["Service"]; });





/***/ }),

/***/ "./src/services/Service.ts":
/*!*********************************!*\
  !*** ./src/services/Service.ts ***!
  \*********************************/
/*! exports provided: Service */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Service", function() { return Service; });
/* harmony import */ var _caching_Cache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../caching/Cache */ "./src/caching/Cache.ts");

var Service = /** @class */function () {
    function Service() {}
    Service.cache = new _caching_Cache__WEBPACK_IMPORTED_MODULE_0__["Cache"]();
    return Service;
}();


/***/ })

/******/ });
});
//# sourceMappingURL=main.js.map